import type React from "react";

import type * as THREE from "three";

import {useSelection} from "../../useSelection";
import {DraggableTransform} from "./DraggableTransform";

interface TransformableGroupProps {
  children: React.ReactNode;
}

export function TransformPositionWithDrag({children}: TransformableGroupProps) {
  const {applyTransformToSelected} = useSelection();

  const handleOnTransform = (matrix: THREE.Matrix4) => {
    applyTransformToSelected(matrix);
  };

  return (
    <DraggableTransform onTransform={handleOnTransform}>
      {children}
    </DraggableTransform>
  );
}
